import { axiosRequest } from '@/util/axios-request';

// 设置月度考勤周期
export var setAttendanceCycle = function setAttendanceCycle(data) {
  return axiosRequest({
    url: '/web/statistics/setAttendanceCycle',
    data: data
  });
};

// 获取月度考勤周期列表
export var getCycleList = function getCycleList(data) {
  return axiosRequest({
    url: '/web/statistics/cycleList',
    data: data
  });
};

// 设置月度汇总考勤的考勤规则
export var setAttendanceSetting = function setAttendanceSetting(data) {
  return axiosRequest({
    url: '/web/statistics/setAttendanceSetting',
    data: data
  });
};

// 获取月度考勤周期设置
export var getAttendanceCycle = function getAttendanceCycle(data) {
  return axiosRequest({
    url: '/web/statistics/getAttendanceCycle',
    data: data
  });
};

// 月度考勤统计
export var attendanceMonth = function attendanceMonth(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceMonth',
    data: data
  });
};

// 导出月度考勤统计
export var attendanceMonthExcel = function attendanceMonthExcel(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceMonthExcel',
    data: data
  });
};
// 获取月度考勤汇总展示的字段
export var attendanceMonthField = function attendanceMonthField(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceMonthField',
    data: data
  });
};

// 考勤统计表格详情
export var attendanceDays = function attendanceDays(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceMonthDetail',
    data: data
  });
};
// 色值枚举
export var attendanceMonthColor = function attendanceMonthColor(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceMonthColor',
    data: data
  });
};

// 更新月度考勤统计
export var attendanceMonthUpdate = function attendanceMonthUpdate(data) {
  return axiosRequest({
    url: '/web/statistics/attendanceMonthUpdate',
    data: data
  });
};

// 获取考勤设置
export var getAttendanceSetting = function getAttendanceSetting(data) {
  return axiosRequest({
    url: '/web/statistics/getAttendanceSetting',
    data: data
  });
};